export default __webpack_public_path__ + "static/media/frame.5ae9e83e.png";